import { gql } from '@apollo/client';

export const CreateCSSStore = gql`
mutation CreateCSSStore($idStore: ID, $content: String) {
  createCSSStore(idStore: $idStore, content: $content) {
    status
  }
}
`;